import React from 'react'
import { Machine, actions } from 'xstate'

import useMachine from './useMachine'
import FetchingWorkshopData from './FetchingWorkshopData'
import RetryError from './RetryError'
import SoldOut from './SoldOut'
import SelectTickets from './SelectTickets'
import ProcessStripeCheckout from './ProcessStripeCheckout'
import RegistrationForm from './RegistrationForm'
import ReviewRegistration from './ReviewRegistration'
import NotLive from './NotLive'

const { assign } = actions

const initialMachineContext = {
  workshopData: null,
  workshopDataError: null,
  ticketSelectionError: null,
  ticketsToPurchase: null,
  purchaseError: null,
  attendees: null,
  registrationError: null,
}

const toggleMachine = Machine({
  context: initialMachineContext,
  id: 'purchase',
  initial: 'fetchingWorkshopData',
  states: {
    fetchingWorkshopData: {
      on: {
        SOLD_OUT: { target: 'soldOut' },
        NOT_LIVE: {
          target: 'notLive',
          actions: [assignPayload('workshopData')],
        },
        SUCCESS: {
          target: 'selectTickets',
          actions: [assignPayload('workshopData')],
        },
        ERROR: {
          target: 'fetchingWorkshopDataError',
          actions: [assignPayload('workshopDataError')],
        },
      },
    },
    fetchingWorkshopDataError: {
      on: {
        TRY_AGAIN: 'fetchingWorkshopData',
      },
    },
    notLive: {},
    soldOut: {},
    selectTickets: {
      on: {
        SUBMIT: {
          target: 'register',
          actions: [assignPayload('ticketsToPurchase')],
        },
        UPDATE_PROMO_CODE: 'fetchingWorkshopData',
      },
    },
    register: {
      initial: 'registrationForm',
      on: {
        START_OVER: {
          target: 'fetchingWorkshopData',
          actions: [clearContext()],
        },
        BACK_TO_TICKETS: {
          target: 'selectTickets',
        },
        APPROVE: 'paymentDetails',
      },
      states: {
        registrationForm: {
          on: {
            SUBMIT: {
              target: 'reviewRegistration',
              actions: [assignPayload('attendees')],
            },
          },
        },
        reviewRegistration: {
          on: {
            CHANGE: 'registrationForm',
          },
        },
      },
    },
    paymentDetails: {
      initial: 'processStripeCheckout',
      on: {
        ERROR: {
          target: 'selectTickets',
          actions: [assignPayload('ticketSelectionError')],
        },
      },
      states: {
        processStripeCheckout: {},
      },
    },
  },
})

const componentMap = {
  fetchingWorkshopData: FetchingWorkshopData,
  fetchingWorkshopDataError: RetryError,
  notLive: NotLive,
  soldOut: SoldOut,
  selectTickets: SelectTickets,
  'paymentDetails.processStripeCheckout': ProcessStripeCheckout,
  'register.registrationForm': RegistrationForm,
  'register.reviewRegistration': ReviewRegistration,
}

function Checkout({ workshop }) {
  const [state, send] = useMachine(toggleMachine, { log: false })

  let Child
  for (let key in componentMap) {
    if (state.matches(key)) {
      Child = componentMap[key]
    }
  }

  return <Child context={state.context} send={send} workshop={workshop} />
}

// quickly assigns `event.payload` to whatever context key you want
function assignPayload(contextKey) {
  return assign({ [contextKey]: (ctx, event) => event.payload })
}

// when they start over, need to clear it all out
function clearContext() {
  return assign(initialMachineContext)
}

export default Checkout
